export type AiClientId = 'claude-ai' | 'claude-code' | 'codex' | 'other';

export type AiClient = {
  id: AiClientId;
  label: string;
  steps: string[];
  command?: string;
};

export function getAiClients(mcpUrl: string): AiClient[] {
  return [
    {
      id: 'claude-ai',
      label: 'Claude app',
      steps: [
        'Open Claude (web or desktop) → Settings → Connectors.',
        'Click "Add custom connector".',
        'Name it "novu" and paste the server URL below.',
        'Click Connect, then approve in the browser tab that opens.',
      ],
    },
    {
      id: 'claude-code',
      label: 'Claude Code',
      steps: ['Run this in your terminal.', 'In Claude Code, run /mcp, pick "novu" and choose Authenticate.'],
      command: `claude mcp add --transport http --scope user novu ${mcpUrl}`,
    },
    {
      id: 'codex',
      label: 'Codex',
      steps: ['Run these in your terminal.', 'Approve in the browser tab that opens.'],
      command: `codex mcp add novu --url ${mcpUrl}\ncodex mcp login novu`,
    },
    {
      id: 'other',
      label: 'Other',
      steps: [
        'Any client that supports remote MCP servers with OAuth works. Add this URL as a streamable HTTP server.',
      ],
    },
  ];
}

export function getSetupPrompt({ mcpUrl, email }: { mcpUrl: string; email: string }) {
  const host = new URL(mcpUrl).host;

  return `Help me connect the GrowthX Novu MCP server to this app.

Server URL: ${mcpUrl}
My Novu account: ${email}

1. Work out which app you are running in: Claude Code, Codex CLI, Claude desktop or claude.ai.
2. Claude Code: run \`claude mcp add --transport http --scope user novu ${mcpUrl}\`, then tell me to run /mcp, pick "novu" and authenticate.
3. Codex CLI: run \`codex mcp add novu --url ${mcpUrl}\`, then \`codex mcp login novu\`.
4. Claude desktop or claude.ai: you cannot add it yourself. Walk me through Settings → Connectors → Add custom connector, name "novu", the URL above, then Connect.
5. A browser window opens on ${host}. If I am already signed in to the dashboard I only click Approve, otherwise I sign in with my Novu email and password.
6. Once connected, call the novu \`whoami\` tool and confirm it returns ${email}. If anything fails, show me the exact error and check the URL first.

Do not change any other MCP servers or settings.`;
}

export function describeUserAgent(userAgent: string | null) {
  if (!userAgent) return null;
  const known = userAgent.match(/(claude-code|Claude-User|Claude|codex[\w-]*|Cursor|node|python[\w-]*)/i);

  return known ? known[1] : userAgent.slice(0, 40);
}
